const COLORS: Record<string, string> = {
  active: 'bg-presence-active',
  away: 'bg-presence-away',
  dnd: 'bg-presence-dnd',
};

const LABELS: Record<string, string> = {
  active: 'elérhető',
  away: 'távol',
  dnd: 'ne zavarj',
  offline: 'nincs bejelentkezve',
};

export function PresenceDot({
  presence = 'offline',
  className = '',
}: {
  presence?: string;
  className?: string;
}) {
  const filled = COLORS[presence];
  const label = LABELS[presence] ?? presence;

  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={[
        'size-2 shrink-0 rounded-full',
        filled ?? 'border-[1.5px] border-ink-faint bg-transparent',
        className,
      ].join(' ')}
    />
  );
}
